import Inbox from './Inbox.container';
export default Inbox;
